import types from "./types"
import { agentService } from "./agentService"

export default {
  agentLogin,
  getBookingHistory,
  resetBookingHistory,
  retrieveBooking,
  searchBooking,
  resetLastSearchedBooking,
  retrieveDashboardReport,
  forgotPassword,
  changePassword,
  createAgency,
  modifyAgency,
  getChildAgencies,
  getAgencyDetails,
  createAgent,
  modifyAgent,
  modifyAgentStatus,
  getChildAgents,
  transferFunds,
  retrieveReportList,
  generateReport,
  acceptTerms,
  verifyMfa,
  resendMfa
}

function agentLogin(iataNumber, userName, password) {
  return dispatch => {
    dispatch(initState());
    return agentService.agentLogin(iataNumber, userName, password);
  }
}

function getBookingHistory(forceRefresh) {
  return (dispatch, getState) => {

    if(!forceRefresh) {
      const state = getState()
      const bookingHistory = state.agent.bookingHistory
      if(bookingHistory && bookingHistory.length > 0) {
        return Promise.resolve(bookingHistory)
      }
    }

    return agentService.getBookingHistory()
    .then(response => {
      dispatch(bookingHistoryResponse(response));
      return response;
    });
  }
}

function resetBookingHistory() {
  return dispatch => {
    dispatch(bookingHistoryResponse([]));
  }
}

function searchBooking(pnr) {
  return (dispatch, getState) => {
    const state = getState();
    const searchHistory = state.agent.searchHistory;
    const booking = searchHistory.find(x => x.pnr === pnr);
    if(booking) {
      dispatch(lastSearchedBooking(booking))
      return Promise.resolve(booking);
    }

    return agentService.retrieveBooking(pnr)
    .then(response => {
      dispatch(retrieveBookingResponse(response));
      dispatch(lastSearchedBooking(response))
      return response;
    });
  }
}

function resetLastSearchedBooking(booking) {
  return (dispatch) => {
    dispatch(lastSearchedBooking(booking))
  }
}


function retrieveBooking(pnr) {
  return (dispatch, getState) => {
    const state = getState();
    const searchHistory = state.agent.searchHistory;
    const booking = searchHistory.find(x => x.pnr === pnr);
    if(booking) {
      return Promise.resolve(booking);
    }

    return agentService.retrieveBooking(pnr)
    .then(response => {
      dispatch(retrieveBookingResponse(response));
      return response;
    });
  }
}

function retrieveDashboardReport(data) {
  return () => agentService.retrieveDashboardReport(data)
}

function forgotPassword(data) {
  return () => agentService.forgotPassword(data)
}

function changePassword(data) {
  return () => agentService.changePassword(data)
}

function createAgency(data) {
  return () => agentService.createAgency(data)
}

function modifyAgency(data) {
  return () => agentService.modifyAgency(data)
}

function createAgent(data) {
  return () => agentService.createAgent(data)
}

function modifyAgent(data) {
  return () => agentService.modifyAgent(data)
}

function modifyAgentStatus(data) {
  return () => agentService.modifyAgentStatus(data)
}

function getChildAgencies(forceRefresh) {
  return (dispatch, getState) => {

    if(!forceRefresh) {
      const state = getState();
      const childAgencies = state.agent.childAgencies;
      if(childAgencies && childAgencies.length > 0) {
        return Promise.resolve(childAgencies);
      }
    }
    return agentService.getChildAgencies()
    .then(response => {
      dispatch(getChildAgenciesResponse(response));
      return response;
    });
  }
}

function getChildAgents(iataNumber) {
  return () => agentService.getChildAgents(iataNumber)
}


function getAgencyDetails(iataNumber) {
  return () => agentService.getAgencyDetails(iataNumber)
}


function transferFunds(data) {
  return () => agentService.transferFunds(data)
}

function retrieveReportList(forceRefresh) {
  return (dispatch, getState) => {

    if(!forceRefresh) {
      const state = getState();
      const reportList = state.agent.reportList;
      if(reportList && reportList.length > 0) {
        return Promise.resolve(reportList);
      }
    }
    return agentService.retrieveReportList()
    .then(response => {
      dispatch(retrieveReportListResponse(response));
      return response;
    });
  }
}

function generateReport(data) {
  return () => agentService.generateReport(data);
}

function acceptTerms(accepted) {
  return () => agentService.acceptTerms(accepted);
}

function verifyMfa(code) {
  return () => agentService.verifyMfa(code);
}

function resendMfa() {
  return () => agentService.resendMfa();
}

function bookingHistoryResponse(payload) {
  return {
    type: types.BOOKING_HISTORY_RESPONSE, 
    payload
  }
}

function retrieveBookingResponse(payload) {
  return {
    type: types.RETRIEVE_BOOKING_RESPONSE,
    payload
  }
}

function lastSearchedBooking(payload) {
  return {
    type: types.LAST_SEARCHED_BOOKING,
    payload
  }
}

function initState() {
  return {
    type: types.INIT_STATE
  }
}

function getChildAgenciesResponse(payload) {
  return {
    type: types.CHILD_AGENCIES_RESPONSE,
    payload
  }
}

function retrieveReportListResponse(payload) {
  return {
    type: types.REPORT_LIST_RESPONSE,
    payload
  }
}